/**
 * A configuration object containing details for HOYA's theme.
 */
export const THEME_CONFIG_HOYA = {
    id: 'f94eb138-28db-42ef-ad19-c2af5a898a96', // Random UUID
    name: 'hoya',
    metadata: { /* ... */ },
};

/**
 * A configuration object containing details for HOYA's theme.
 */
export const THEME_CONFIG_SEIKO = {
    id: 'e332044b-0fe0-4266-89f6-f093b3e55f53', // Random UUID
    name: 'seiko',
    metadata: { /* ... */ },
};

/**
 * An array of all theme configurations that are currently available on the site.
 */
export const ALL_THEME_CONFIGS = [
    THEME_CONFIG_HOYA,
    THEME_CONFIG_SEIKO,
];
